import { render } from "./B2bFiltersAuditoriaAcciones.vue?vue&type=template&id=58e5f26a&scoped=true&lang=pug"
import script from "./B2bFiltersAuditoriaAcciones.vue?vue&type=script&lang=js"
export * from "./B2bFiltersAuditoriaAcciones.vue?vue&type=script&lang=js"

import "./B2bFiltersAuditoriaAcciones.vue?vue&type=style&index=0&id=58e5f26a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e5f26a"]])

export default __exports__